import { render } from "./PageContentLayout.vue?vue&type=template&id=187acf3d&ts=true"
import script from "./PageContentLayout.vue?vue&type=script&lang=ts"
export * from "./PageContentLayout.vue?vue&type=script&lang=ts"

import "./PageContentLayout.vue?vue&type=style&index=0&id=187acf3d&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__